import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <div className="footer">
      <p>&copy; {new Date().getFullYear()} Lara's Portfolio</p>
      <p>  With love from Portugal💗</p>
    </div>
  );
}

export default Footer;